import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postJson } from '../lib/api.ts';
import { getSession, saveSession } from '../lib/session.ts';

const VerificationPage = () => {
  const navigate = useNavigate();
  const session = getSession();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  if (!session) {
    navigate('/identification');
    return null;
  }

  const handleSubmit = async (event: React.SubmitEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (code.trim().length !== 6) {
      setError('Informe um código de 6 dígitos recebido no WhatsApp.');
      return;
    }

    try {
      const result = await postJson<{ verified: boolean }>(
        `/api/auth/${session.customerId}/verify-otp`,
        { code }
      );

      if (!result.verified) {
        setError('Código inválido.');
        return;
      }

      saveSession({ ...session, otp: code });
      navigate('/companies');
    } catch (error) {
      setError((error as Error).message);
    }
  };

  return (
    <main className="space-y-8">
      <section className="rounded-3xl bg-white p-8 shadow-md shadow-slate-200">
        <p className="text-sm uppercase tracking-[0.3em] text-red-600">Verificação</p>
        <h1 className="mt-4 text-3xl font-semibold text-red-600">Digite o código enviado no WhatsApp</h1>
        <p className="mt-3 text-slate-500">O código foi enviado para {session.phone}. Use-o para continuar.</p>
      </section>

      <form onSubmit={handleSubmit} className="grid gap-4 rounded-3xl bg-red-50 p-8 shadow-inner shadow-slate-100">
        {error && <div className="rounded-2xl bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>}

        <label className="space-y-2">
          <span className="text-sm text-slate-700">Código OTP</span>
          <input
            value={code}
            onChange={(event) => setCode(event.target.value)}
            className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-slate-600 shadow-sm outline-none transition focus:border-slate-400"
            placeholder="XXXXXX"
            maxLength={6}
          />
        </label>

        <button
          type="submit"
          className="mt-4 inline-flex w-full justify-center rounded-2xl bg-red-600 px-5 py-4 text-sm font-semibold text-white shadow-lg shadow-slate-200 transition hover:bg-red-700"
        >
          Confirmar código
        </button>
      </form>
    </main>
  );
};

export default VerificationPage;
